import type { AstroProduct } from './astroProduct.model';

export type SecondaryMarketAstroProductActions =
  | SecondaryMarketAstroProductFetchRequested
  | SecondaryMarketAstroProductFetched
  | SecondaryMarketAstroProductFetchFailed
  | SecondaryMarketAstroProductFetchProductNotFound;

// ////////////////////////////////////

export function secondaryMarketAstroProductFetchRequested(
  isin: string,
  tabId?: string,
  createTabOnAstroProductFetched?: boolean,
) {
  return {
    type: 'SECONDARY_MARKET_ASTRO_PRODUCT_FETCH_REQUESTED' as const,
    tabId,
    isin,
    createTabOnAstroProductFetched,
  };
}
export type SecondaryMarketAstroProductFetchRequested = ReturnType<typeof secondaryMarketAstroProductFetchRequested>;

// ////////////////////////////////////

export function secondaryMarketAstroProductFetched(isin: string, data: AstroProduct) {
  return {
    type: 'SECONDARY_MARKET_ASTRO_PRODUCT_FETCHED' as const,
    isin,
    data,
  };
}
export type SecondaryMarketAstroProductFetched = ReturnType<typeof secondaryMarketAstroProductFetched>;

// ////////////////////////////////////

export function secondaryMarketAstroProductFetchFailed(isin: string, errorMessage: string) {
  return {
    type: 'SECONDARY_MARKET_ASTRO_PRODUCT_FETCH_FAILED' as const,
    isin,
    errorMessage,
  };
}
export type SecondaryMarketAstroProductFetchFailed = ReturnType<typeof secondaryMarketAstroProductFetchFailed>;

// ////////////////////////////////////

export function secondaryMarketAstroProductFetchProductNotFound(isin: string) {
  return {
    type: 'SECONDARY_MARKET_ASTRO_PRODUCT_FETCH_PRODUCT_NOT_FOUND' as const,
    isin,
  };
}
export type SecondaryMarketAstroProductFetchProductNotFound = ReturnType<
  typeof secondaryMarketAstroProductFetchProductNotFound
>;
